import React, {
  createContext,
  useCallback,
  useContext,
  useReducer,
} from "react";
import { useRouteMatch } from "react-router-dom";
import PropTypes from "prop-types";

export const OnboardingContext = createContext();

export const useOnboardingStepsData = () => {
  return useContext(OnboardingContext);
};

export function OnboardingStepsProvider({ initialState, children }) {
  const [store, dispatch] = useReducer((state, { type, value }) => {
    switch (type) {
      case "update-step-data":
        return { ...state, ...value };
      default:
        return initialState;
    }
  }, initialState);

  return (
    <OnboardingContext.Provider value={{ dispatch, store }}>
      {children}
    </OnboardingContext.Provider>
  );
}
OnboardingStepsProvider.propTypes = {
  initialState: PropTypes.object,
  children: PropTypes.node.isRequired,
};

OnboardingStepsProvider.defaultProps = {
  initialState: {},
};

export function withStep(WrappedComponent) {
  const WithStep = ({ id, ...props }) => {
    const { dispatch } = useOnboardingStepsData();
    const { url } = useRouteMatch();

    const onUpdate = useCallback(
      (data) => {
        dispatch({ type: "update-step-data", value: { [id]: { ...data } } });
      },
      [dispatch, id]
    );

    if (url.includes(id)) {
      return <WrappedComponent id={id} onUpdate={onUpdate} {...props} />;
    }
    return null;
  };

  WithStep.propTypes = { id: PropTypes.string.isRequired };

  return WithStep;
}
